import { render, staticRenderFns } from "./BlockItem.vue?vue&type=template&id=4b6b06fd&scoped=true&"
import script from "./BlockItem.vue?vue&type=script&lang=js&"
export * from "./BlockItem.vue?vue&type=script&lang=js&"
import style0 from "./BlockItem.vue?vue&type=style&index=0&id=4b6b06fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6b06fd",
  null
  
)

export default component.exports